module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3gEJDigBhEwC8wAAATtJREFUKM+F0jFLllEYxvHf+0bg3KB2lqChIYqgexAaHEUE+wC5WBBIZK3RUEHgVwiCFKSpXJP6DHGDu1JB4LEip6xoiJbz5sNT6DXe5/zPdd0XZ6ApIs7gMWYwgR28wAoOMlNXwwbN4QPGMY+zuIur+IZJPQ2b0ytMZ+Ys3mbme2xm5kU8wLtmcEhGxHpEvHaEIuJ3RCz2o87gXkQ8PYK9g6U+OIHPuPlPnEN9wlQf3MF5bEfEk8z8H3wJm93BiVLKZGvwCjZKKeewW0r5WWv9HhFjeINrtdbdruMKLuA2xvAFj3A5Ik7iJfbxsbvKEAc4jfv40aI/wzR+tSSnsBcRC6NVBr3aF1t7U22nh81pr3PtRmauDTqQ/rfqnC3geWe0PHCMRg9GxHWs/m31OLDWOoK3SilfMYdbfwCBsGMAyM9nwQAAAABJRU5ErkJggg=="


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/search_14.png
 ** module id = 297
 ** module chunks = 0 1
 **/